/** A saved Action owns replay and new-run admission; generic task retries cannot clone it. */
export function actionInstanceRunReference(output: unknown): { actionId: string | null; origin: "source_analytics" | "standalone" } | null {
  let value = output;
  if (typeof value === "string") {
    try { value = JSON.parse(value); } catch { return null; }
  }
  if (!value || typeof value !== "object" || Array.isArray(value)) return null;
  const record = value as Record<string, unknown>;
  for (const key of ["action_run", "action_schedule", "source_run", "scheduling"]) {
    if (!Object.prototype.hasOwnProperty.call(record, key)) continue;
    const metadata = record[key];
    const id = metadata && typeof metadata === "object" && !Array.isArray(metadata)
      ? (metadata as Record<string, unknown>)[key === "source_run" ? "action_id" : "action_instance_id"] : null;
    return { origin: key === "source_run" ? "source_analytics" : "standalone", actionId: typeof id === "string" && /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(id) ? id : null };
  }
  return null;
}

/** Preserve the exact historical shape and truthiness used by retry fences. */
export function actionInstanceRunIdentity(output: unknown): { actionId: string | null } | null {
  const reference = actionInstanceRunReference(output);
  return reference ? { actionId: reference.actionId } : null;
}
